import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    shareSwitchList: [],
    shareChildSwitch: false,
    checkShareList: []
  },
  getters: {
    shareSwitchList: state => {
      return state.shareSwitchList;
    }
  },
  mutations: {
    setShareSwitchList(state, data) {
      state.shareSwitchList = data;
    },
    setShareChildSwitch(state, data) {
      state.shareChildSwitch = data;
    },
    setCheckShareList(state, data) {
      state.checkShareList = data;
    }
  },
  actions: {
    // eslint-disable-next-line
    getShareSwitchList({ commit }) {
      api.getShareSwitchList().then(({ data }) => {
        commit('setShareSwitchList', data);
      });
    },
    turnOnSwitch(context, switchKey) {
      return api.turnOnSwitch(switchKey);
    },
    turnOffSwitch(context, switchKey) {
      return api.turnOffSwitch(switchKey);
    },
    getShareChildSwitch({ commit }, query) {
      api.getShareChildSwitch(query).then(({ data }) => {
        commit('setShareChildSwitch', data);
      });
    },
    turnOnChildSwitch(context, data) {
      return api.turnOnChildSwitch(data);
    },
    turnOffChildSwitch(context, data) {
      return api.turnOffChildSwitch(data);
    },
    checkShare() {
      return api.checkShare();
    },
    getCheckShareList({ commit }, query) {
      api.getCheckShareList(query).then(({ data }) => {
        commit('setCheckShareList', data);
      });
    }
  }
};

appStore.registerModule('miningShare', store);
